import { connect } from "react-redux";
import Invoice from "./invoice";
import { bindActionCreators } from "redux";
import { getInvoiceList } from "services/redux/brandActivtion/Invoice/action";

const mapStateToProps = (state) => ({
    invoiceList: state.InvoiceReducer.invoiceList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getInvoiceList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
